import React from 'react'
import Container from '../../components/Template/container'
import Program from '../../components/Clinic/Programs/Program'

class ProgramView extends React.Component {
  render() {
    return <Container
      className="program"
      currentItem="clinic/programs"
      sidebar={<div className="sidebar-default" />}
    >
      <Program />
    </Container>
  }
}

export default ProgramView